import { useState, useEffect, Suspense } from 'react';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFirestore, getDoc, doc, collection, getDocs, query, where } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { app } from './firebase.config.js';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import './App.css';
import './css/MyStyles.css';
import { useTranslation } from 'react-i18next';

/**
 * 
 * @param exchangetime - Hora de troca de turno como inteiro
 * @returns {now, vetday}
 * now - Dia atual em formato YYYY-MM-DD
 * vetday - Dia a utilizar para efeito de apurar o veterinário de serviço (YYYY-MM-SS)
 */
const getNow = (exchangetime) => {
  const dd = new Date();
  const today = new Date(dd);
  if (dd.getHours() < exchangetime) dd.setDate(dd.getDate() - 1)
  return {now:today.toLocaleDateString('pt-br').split('/').reverse().join('-'), vetday:dd.toLocaleDateString('pt-br').split('/').reverse().join('-')}
}

function App() {
  const [vet, setVet] = useState(); // Veterinário de serviço. ATENÇÃO: Nada tem a ver com o utilizador que está aceder à app
  const [today, setToday] = useState('');
  const [loaded, setLoaded] = useState();
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    if (vet !== undefined) setLoaded(true);
  }, [vet]);

  useEffect(() => {
    const fff = async () => {
      try {
        const auth = getAuth(app);
        await signInAnonymously(auth);
        const db = getFirestore(app);
        const globalRef = doc(db, "global", "data");
        const globalSnap = await getDoc(globalRef);
        const exchangetime = globalSnap.data().exchangetime;
        
        //const {now, vetday} = getNow(exchangetime); //new Date().toISOString().slice(0, 10);
        const x = getNow(exchangetime); //new Date().toISOString().slice(0, 10);
        
        const { now, vetday} = x;

        let ym = vetday.slice(0, 7);
        let day = vetday.slice(8, 10);
        setToday(now.slice(0,10));
        

        // Para o dia atual procura o id do vet de serviço
        const docRef = doc(db, "days", ym);
        const docSnap = await getDoc(docRef);
        let data = docSnap.data();
        let vetid = data[day];
        if (vetid !== undefined) {
          // Procura o vet pelo seu id
          const q = query(collection(db, "users"), where("id", "==", vetid));
          const querySnap = await getDocs(q);
          let dd = querySnap.docs[0].data();
          const storage = getStorage();
          const userRef = ref(storage, 'photos/' + vetid + '.jpeg');
          getDownloadURL(userRef).then((url) => {
            setVet({ ...dd, photo: { uri: url } })
          }).catch((error) => {
            setVet({ ...dd, photo: require('./assets/user.png') })
          });
        } else setLoaded(true);

      } catch (error) {
        console.log(error)
      }
    }
    fff();
  }, []);
  return (
    <div className="App" style={{ height: '100vh', display: 'flex', flex: 1, flexDirection: 'column', backgroundColor: 'dimgrey' }}>
      <Paper style={{ height: 110, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', margin: 10, padding: 10, marginTop: 10 }} elevation={3}>
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          <img src='./assets/vet_logo_ss.png' alt="logo" width={120} />
        </div>
        <div style={{ display: 'flex', flex: 2, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: 'bold' }}>{t('global_title')}</p>
          <p style={{ margin: 0, fontSize: '1.0rem' }}>{t('entry_emergency')}</p>
        </div>
      </Paper>
      {vet !== undefined ?
        <Paper style={{ display: 'flex', flexDirection: 'row', margin: 10, marginTop:0, padding: 10, flexGrow: '1', alignItems:'center' }} elevation={3}>
          <div style={{ display: 'flex', flex: 30, flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ margin: 0, marginBottom: 10, fontSize: '1.2rem', fontWeight: 'bold', color: 'orange' }}>{today}</p>
            <img src={vet.photo.uri} alt="logo" width={200} style={{ borderRadius: 40, maxWidth: '90%' }} />
          </div>
          <div style={{ display: 'flex', flex: 1 }}></div>
          <div style={{ display: 'flex', flex: 6, justifyContent: 'center', alignItems: 'flex-start', paddingTop: 5 }}>
            <a href={'https://maps.google.com/?q=' + vet.latitude + ',' + vet.longitude + '&z=8'} target="_blank"><img src='./assets/googlemapsss.png' alt="logo" height={50} /></a>
          </div>
          <div style={{ display: 'flex', flex: 1 }}></div>
          <div style={{ display: 'flex', flex: 24, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: 10 }}>
            <div style={{ display: 'flex', flex: 4, flexDirection: 'column' }}>
              <p style={{ margin: 0, textAlign: 'left', fontWeight:'bold', fontSize: '1.5rem' }}>{vet.clinic}</p>
              <p style={{ margin: 0, textAlign: 'left', fontSize: '1.1rem' }}>{vet.street}</p>
              <p style={{ margin: 0, textAlign: 'left', fontSize: '1.0rem' }}>{vet.city}</p>
              <p style={{ margin: 0, textAlign: 'left', fontSize: '0.8rem' }}>{vet.latitude.toFixed(4)}, {vet.longitude.toFixed(4)}</p>
            </div>
            <div style={{ display: 'flex', flex: 3, flexDirection: 'column' }}>
              <div style={{ display: 'flex', flex: 1, paddingTop: 15 }}>
                <Button variant="contained" style={{ maxHeight: 40, width: 120 }} href={'tel:' + vet.mobile}>{vet.mobile}</Button>
              </div>
              <div style={{ display: 'flex', flex: 1, paddingTop: 15 }}>
                <Button variant="contained" style={{ maxHeight: 40, width: 120 }} href={'tel:' + vet.phone}>{vet.phone}</Button>
              </div>
            </div>
            <div style={{ display: 'flex', flexGrow: '1' }}></div>
          </div>
        </Paper>
        : (loaded === undefined ?
          <Paper style={{ display: 'flex', margin: 10, padding: 20, marginTop: 10, justifyContent: 'center', alignItems: 'center', flexGrow: '1' }} elevation={3}>
            <p>A carregar dados ...</p>
          </Paper>
          :
          <Paper style={{ display: 'flex', margin: 10, padding: 20, marginTop: 10, justifyContent: 'center', alignItems: 'center', flexGrow: '1' }} elevation={3}>
            <p>{t('calendardetails_novet')}</p>
          </Paper>
        )
      }
      <Paper style={{ height: 80, display: 'flex', flexDirection: 'row', margin: 10, marginTop: 0, padding: 5 }} elevation={3}>
        <div style={{ display: 'flex', flex: 3, flexDirection: 'column', justifyContent: 'center', alignItems: 'start' }}>
          <p style={{ margin: 0, textAlign: 'left', fontSize: '0.6rem', fontWeight: 'bold' }}>{t('entry_collaboration')}:</p>
          <p style={{ margin: 0, fontSize: '0.5rem' }}><a href='mailto: pmatos@ipb.pt'>{t('entry_supportteam')}</a></p>
        </div>
        <div style={{ display: 'flex', flex: 4, alignItems: 'center' }}>
          <a href='https://www.cm-braganca.pt' target="_blank">
            <img src='./assets/CMB2s.png' alt="logo" width={250} style={{maxWidth:'70%'}} />
          </a>
        </div>
        <div style={{ display: 'flex', flex: 4, alignItems: 'center' }}>
          <a href='https://www.ipb.pt' target="_blank">
            <img src='./assets/IPB2s.png' alt="logo" width={250} style={{maxWidth:'70%'}} />
          </a>
        </div>
      </Paper>
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...loading">
      <App />
    </Suspense>
  )
}

//export default App;
